import { render } from "./UserInputTest.vue?vue&type=template&id=b5427af6&scoped=true"
import script from "./UserInputTest.vue?vue&type=script&lang=js"
export * from "./UserInputTest.vue?vue&type=script&lang=js"

import "./UserInputTest.vue?vue&type=style&index=0&id=b5427af6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5427af6"]])

export default __exports__